import isEmail from "sane-email-validation";

export const getFieldInfo = (fieldInfo, ticket) => {
  if (ticket) return fieldInfo.registerTicket;
  return fieldInfo.registerMember;
};

export const validate = (
  values,
  language,
  ticket,
  requiredFields,
  visibleFields
) => {
  // console.log(values, requiredFields, visibleFields);
  const errors = {};
  if (requiredFields.includes("firstname") && !values.firstname) {
    errors.firstname =
      language.MemberForm && language.MemberForm.FirstName_Required;
  } else if (values.firstname.length > 100) {
    errors.firstname = language.MemberForm.Invalid_Length || "Ogiltig längd";
  }
  if (requiredFields.includes("lastname") && !values.lastname) {
    errors.lastname =
      language.MemberForm && language.MemberForm.LastName_Required;
  } else if (values.lastname.length > 100) {
    errors.lastname = language.MemberForm.Invalid_Length || "Ogiltig längd";
  }
  if (requiredFields.includes("email") && !values.email) {
    errors.email =
      (language.MemberForm && language.MemberForm.Email_Required) ||
      "Ogiltig längd";
  } else if (
    values.email &&
    values.email.length > 0 &&
    !isEmail(values.email)
  ) {
    errors.email = language.MemberForm && language.MemberForm.Email_Invalid;
  } else if (values.email.length > 100) {
    errors.email = language.MemberForm.Invalid_Length || "Ogiltig längd";
  }
  if (
    requiredFields.includes("civicRegistrationNumber") &&
    !values.civicRegistrationNumber
  ) {
    errors.civicRegistrationNumber =
      language.MemberForm && language.MemberForm.CivicRegistration_Required;
  } else if (
    !/^(19|20)?[0-9]{6}[- ]?[0-9]{4}$/.test(values.civicRegistrationNumber) &&
    visibleFields.includes("civicRegistrationNumber")
  ) {
    errors.civicRegistrationNumber =
      language.MemberForm && language.MemberForm.CivicRegistration_Invalid;
  }
  if (requiredFields.includes("zipCode") && !values.zipCode) {
    errors.zipCode =
      language.MemberForm && language.MemberForm.ZipCode_Required;
  } else if (values.zipCode && values.zipCode > 98999) {
    errors.zipCode = language.MemberForm && language.MemberForm.ZipCode_Invalid;
  } else if (
    values.zipCode &&
    !/^[0-9]{2,3}(\s?){0,1}[0-9]{2,}$/.test(values.zipCode)
  ) {
    errors.zipCode = language.MemberForm && language.MemberForm.ZipCode_Invalid;
  }
  if (ticket && !values.id) {
    errors.id = language.MemberForm && language.MemberForm.TicketId_Required;
  }
  // console.log(errors);
  return errors;
};
